import { render } from "./CmsPage.vue?vue&type=template&id=1cc95c60&lang=html"
import script from "./CmsPage.vue?vue&type=script&lang=js"
export * from "./CmsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__